import { useContext } from 'react'

import { ReabRouteContext } from '@provider/Parametrization/ReabRouteProvider'

import { IReabRoutesProvider } from '@base/@types/providers/Parametrization/ReabRoutesProvider'

export default function useReabRoutes(): IReabRoutesProvider {
  const context = useContext(ReabRouteContext)

  return context
}
